const options = {
  5: "bg-cyan-700/5",
  10: "bg-cyan-700/10",
  25: "bg-cyan-700/25",
  50: "bg-cyan-700/50",
  75: "bg-cyan-700/75",
  90: "bg-cyan-700/90",
  100: "bg-cyan-700",
};

const from = {
  5: "from-cyan-700/5",
  10: "from-cyan-700/10",
  25: "from-cyan-700/25",
  50: "from-cyan-700/50",
  75: "from-cyan-700/75",
  90: "from-cyan-700/90",
  100: "from-cyan-700",
};

export default function getBackgroundCyan700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
